export default {
	methods: {
		clearForm(form){ this[form] = this.$options.data.call(this)[form] },
	}
};
